import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  onBack?: () => void;
  onSkip?: () => void;
}
export function ProgressBar({
  currentStep,
  totalSteps,
  onBack,
  onSkip
}: ProgressBarProps) {
  let phase = 'Icebreaker';
  if (currentStep >= 3 && currentStep <= 6) phase = 'Deep Dive';
  if (currentStep >= 7 && currentStep <= 10) phase = 'Strategy';
  if (currentStep >= 11) phase = 'Share Back';
  const progress = currentStep / totalSteps * 100;
  return <div className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-261">
      <div className="max-w-4xl mx-auto px-4 py-3 flex justify-between items-center text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-262">
        <button onClick={onBack} disabled={currentStep <= 1} className="flex items-center gap-1 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors normal-case tracking-normal" aria-label="Go back" data-id="element-263">
          <ChevronLeft size={16} data-id="element-264" />
          <span className="hidden sm:inline" data-id="element-265">Back</span>
        </button>

        <div className="flex space-x-5" data-id="element-266">
          <span className={phase === 'Icebreaker' ? 'text-brand' : ''} data-id="element-267">
            Icebreaker
          </span>
          <span className={phase === 'Deep Dive' ? 'text-brand' : ''} data-id="element-268">
            Deep Dive
          </span>
          <span className={phase === 'Strategy' ? 'text-brand' : ''} data-id="element-269">
            Strategy
          </span>
          <span className={phase === 'Share Back' ? 'text-brand' : ''} data-id="element-270">
            Share Back
          </span>
        </div>

        <button onClick={onSkip} disabled={currentStep >= totalSteps} className="flex items-center gap-1 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors normal-case tracking-normal" aria-label="Skip forward" data-id="element-271">
          <span className="hidden sm:inline" data-id="element-272">Skip</span>
          <ChevronRight size={16} data-id="element-273" />
        </button>
      </div>
      <div className="h-1 w-full bg-gray-100" data-id="element-274">
        <motion.div className="h-full bg-brand" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-275" />
      </div>
    </div>;
}